import {useState} from 'react';

import {NodeLabelColor} from 'src/types';

export const useTypes = () => {
  const [nodeTypes, setNodeTypes] = useState<Array<NodeLabelColor>>([]);
  const [linkTypes, setLinkTypes] = useState<Array<NodeLabelColor>>([]);

  const onNodesAdded = (nodes) => {
    const types: Array<NodeLabelColor> = [];
    nodes.forEach((nd) => {
      const type = nd.metadata.type;
      if (
        (nodeTypes.length === 0 || nodeTypes.filter((nt) => nt.type === type).length === 0) &&
        (types.length === 0 || types.filter((nt) => nt.type === type ).length === 0)
      ) {
        types.push({
          type: nd.metadata.type,
          color: nd.color,
          fgColor: 'white',
        });
      }
    });
    setNodeTypes([
      ...nodeTypes, ...types,
    ]);
  };

  const onLinksAdded = (links) => {
    const types: Array<NodeLabelColor> = [];
    links.forEach((ld) => {
      const type = ld.type || ld.groups && 'GROUPS' || 'UNKNOWN';
      if (
        (linkTypes.length === 0 || linkTypes.filter((lt) => lt.type === type).length === 0) &&
        (types.length === 0 || types.filter((nt) => nt.type === type ).length === 0)
      ) {
        types.push({
          type: type,
          color: ld.color,
          fgColor: 'white',
        },
        );
      }
    });
    setLinkTypes([
      ...linkTypes, ...types,
    ]);
  };

  return {
    nodeTypes,
    onNodesAdded,
    linkTypes,
    onLinksAdded,
  } as const;
};
